import { WidgetCard } from '../atoms/WidgetCard';
import { NoteWidgetEditModeHeaderBar } from '../atoms/EditModeChartWidgetHeaderBar';
import { WidgetBody } from '../atoms/WidgetBody';
import { FlexBox } from '@ardoq/layout';
import { Header1 } from '@ardoq/typography';
import styled from 'styled-components';
import { PowerBiIframeWidgetProps } from '../renderTypes';
import { DashboardModes } from '../../types';
import { type WithI18nLocale, t } from '@ardoq/i18n';
import { isAllowedPowerBiUrl } from './getPowerBiIframeWidgetProps';

const PlaceholderText = styled(Header1)`
  font-size: 1.2rem;
`;

const IframeContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const StyledIframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
`;

export const PowerBiIframeWidget = (
  props: PowerBiIframeWidgetProps & WithI18nLocale
) => {
  const { isInEditMode, _id, layout, url, i18nLocale } = props;

  return (
    <WidgetCard
      widgetId={_id}
      dashboardMode={isInEditMode ? DashboardModes.EDIT : DashboardModes.VIEW}
      layout={layout}
      isSelected={isInEditMode && props.isSelected}
      hasError={isInEditMode && props.hasError}
    >
      {isInEditMode && !props.isInLinkDashboardFiltersMode && (
        <NoteWidgetEditModeHeaderBar
          commands={props.commands}
          isSaving={props.isSaving}
          i18nLocale={i18nLocale}
        />
      )}
      <WidgetBody hasHeader={isInEditMode}>
        <FlexBox
          width={'full'}
          height={'full'}
          align={'center'}
          justify={'center'}
        >
          {isAllowedPowerBiUrl(url) ? (
            <IframeContainer>
              <StyledIframe
                src={url}
                title="PowerBI Dashboard"
                sandbox="allow-scripts allow-same-origin allow-popups"
                referrerPolicy="no-referrer"
              />
            </IframeContainer>
          ) : (
            <PlaceholderText color={'textSubtle'}>
              {t(
                i18nLocale,
                'dashboard:powerBiWidget.noValidUrl',
                'No valid PowerBI URL'
              )}
            </PlaceholderText>
          )}
        </FlexBox>
      </WidgetBody>
    </WidgetCard>
  );
};
